export const darkTheme = {
    background: '#121212',
    header: '#1a1a1a',
    cardBackground: '#1f1f1f',
    text: '#e0e0e0',
    accent: '#ff6347',
    gradient: 'linear-gradient(135deg, #1e1e1e 0%, #121212 100%)'
  };  